import { CustomerType } from '@repo/common';
import { motion } from 'framer-motion';
import { BiShoppingBag, BiStore } from 'react-icons/bi';
import { FaUserSecret } from 'react-icons/fa';

import { useCreateSale } from './create-sale.hook';

// type CustomerType = 'Wholesale' | 'Retail' | 'Walk-in';
function SaleCustomer() {
    const { changeCustomerTypeName, customerType, cartData } = useCreateSale();

    const customerTypeInfo = {
        [CustomerType.WALKIN]: {
            icon: BiShoppingBag,
            color: ' border-yellow-300',
        },
        [CustomerType.WHOLESALE]: {
            icon: FaUserSecret,
            color: 'border-blue-300',
        },
        [CustomerType.RETAIL]: { icon: BiStore, color: ' border-green-300' },
    };

    const setDisabled = (type: CustomerType) => {
        if (cartData?.data.items.length && customerType !== type) {
            return true;
        }
        return false;
    };

    return (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
            {(Object.keys(customerTypeInfo) as CustomerType[]).map((type) => {
                const { icon: Icon, color } = customerTypeInfo[type];
                return (
                    <motion.button
                        key={type}
                        type="button"
                        disabled={setDisabled(type)}
                        onClick={() => changeCustomerTypeName(type)}
                        className={`relative flex rounded-lg border-2 p-4 text-left capitalize transition-all ${
                            customerType === type
                                ? `${color} border-opacity-100 bg-white text-primary`
                                : 'border-transparent text-white'
                        }`}
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                    >
                        <Icon className="mb-2 mr-2 h-8 w-8" />
                        <div>
                            <h3 className="font-medium">{type}</h3>
                            <p className={`text-sm  ${color}`}>
                                {type === CustomerType.WALKIN &&
                                    'On-site purchases'}
                                {type === CustomerType.WHOLESALE &&
                                    'Bulk orders'}
                                {type === CustomerType.RETAIL &&
                                    'Individual sales'}
                            </p>
                        </div>
                        {customerType === type && (
                            <motion.div
                                className="absolute inset-0 rounded-lg border-2 border-primary"
                                layoutId="outline"
                                initial={false}
                                transition={{
                                    type: 'spring',
                                    stiffness: 500,
                                    damping: 30,
                                }}
                            />
                        )}
                    </motion.button>
                );
            })}
        </div>
    );
}

export default SaleCustomer;
